// Format a raw formula for human display:
//   - strip bracket notation so [#337-2748] renders as #337-2748
//   - replace `CODE@baseline` with `CODE (YYYY)` when the disclosure's
//     baselineYear is known, otherwise `CODE (baseline)`
//   - pad infix operators so `A+B-C` reads as `A + B - C`
//
// Used by every read-only formula renderer so parser syntax never leaks
// into the UI. Pure string transform — no parsing, safe on any input.
const ANCHORED_REF_RE = /([A-Z][\w-]*\d+)@baseline/g;

export const humanizeFormula = (formula, { baselineYear } = {}) => {
  if (!formula) return formula;
  const label = baselineYear ? String(baselineYear) : "baseline";

  // Stash bracket-quoted codes so operator-padding doesn't mangle hyphens
  // inside them (e.g. [#337-2748] must stay as #337-2748, not #337 - 2748).
  const stash = [];
  const withPlaceholders = formula.replace(/\[([^\]]+)\]/g, (_, inner) => {
    stash.push(inner);
    return `\x00${stash.length - 1}\x00`;
  });

  const processed = withPlaceholders
    .replace(ANCHORED_REF_RE, `$1 (${label})`)
    .replace(/([+\-*/])/g, " $1 ")
    .replace(/\s+/g, " ")
    .trim();

  return processed.replace(/\x00(\d+)\x00/g, (_, i) => stash[Number(i)]);
};
